module.exports = __webpack_public_path__ + "static/media/teste.d8065139.mp4";